var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.257 25.5229L26.82 33.4369L18.957 28.1619",
    fill: "#7BEEA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.179 31.7901C22.0098 31.7901 28.358 25.442 28.358 17.6111C28.358 9.78028 22.0098 3.43213 14.179 3.43213C6.34815 3.43213 0 9.78028 0 17.6111C0 25.442 6.34815 31.7901 14.179 31.7901Z",
    fill: "#7BEEA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9353 22.0911L30.4993 30.0051L22.6353 24.7301",
    fill: "#28A6DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8582 28.358C25.689 28.358 32.0372 22.0098 32.0372 14.179C32.0372 6.34816 25.689 0 17.8582 0C10.0274 0 3.6792 6.34816 3.6792 14.179C3.6792 22.0098 10.0274 28.358 17.8582 28.358Z",
    fill: "#28A6DC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8299 22.2261L28.6729 31.9511L20.2749 26.4021",
    fill: "#201E31"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4978 30.0299C23.3287 30.0299 29.6768 23.6817 29.6768 15.8509C29.6768 8.02003 23.3287 1.67188 15.4978 1.67188C7.667 1.67188 1.31885 8.02003 1.31885 15.8509C1.31885 23.6817 7.667 30.0299 15.4978 30.0299Z",
    fill: "#201E31"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5871 14.896H12.1401V16.826H17.5871V14.896Z",
    fill: "#201E31"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7633 6.05203C15.5963 6.27103 15.5163 6.37603 15.4113 6.51503C16.8583 6.05203 18.0433 6.42903 19.2093 7.39003C18.9493 7.56803 18.8143 7.74203 18.6843 7.73803C17.3203 7.69903 16.2853 8.27303 15.4543 9.33003C13.3173 12.049 11.7223 15.037 10.9303 18.416C10.7303 19.268 10.7223 20.164 10.6263 21.039C10.7173 21.084 10.8093 21.129 10.8993 21.176C11.2023 20.93 11.5623 20.727 11.7983 20.428C13.5543 18.213 15.2853 15.981 17.0433 13.729C16.5643 13.428 16.1483 13.168 15.6093 12.829C18.2543 12.304 20.7303 11.991 23.3483 12.931C22.3503 13.259 21.4983 13.517 20.6663 13.826C20.4443 13.91 20.1773 14.109 20.1033 14.314C18.8313 17.857 17.8113 21.459 17.7803 25.263C17.7793 25.493 17.8753 25.722 17.9003 25.954C17.9203 26.134 17.8993 26.319 17.8973 26.501C17.6813 26.458 17.3273 26.48 17.2723 26.36C17.0513 25.887 16.7803 25.372 16.7833 24.874C16.7973 22.517 16.8953 20.161 16.9603 17.905C16.9843 17.878 16.8703 17.997 16.7733 18.132C16.1523 19.007 15.6093 19.948 14.8953 20.737C14.2733 21.425 13.4903 21.979 12.7223 22.51C12.3213 22.787 11.8233 22.944 11.2883 22.647C11.0633 22.524 10.7303 22.612 10.4593 22.551C9.17926 22.266 8.53226 21.307 8.27126 20.16C8.10026 19.402 8.10726 18.533 8.30026 17.781C9.32726 13.787 11.0243 10.111 13.9393 7.11703C14.3773 6.66603 14.8143 6.00403 15.7633 6.05203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a3b9ffacd10905a14fb251cb9013e53f.svg";
export { ForwardRef as ReactComponent };